import React, {Component} from 'react';



class Publicitat extends Component {

    
render() {   


  return (
    <div>
      {/* <div className="publicitat">
              <span>Amb el suport de: </span>
              <img src={process.env.PUBLIC_URL + "/img/euronics.svg"} />
      </div> */}
    </div>
  );
}

}

export default Publicitat; 